import React, { useState, useEffect } from 'react';
import { Box, Typography, Grid, Paper } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

function RegisterCountdownTimer({ targetDate, showIcon = true, variant = 'default' }) {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const targetDateObj = targetDate ? new Date(targetDate) : null;
    if (!targetDateObj || isNaN(targetDateObj.getTime())) return;
    const timer = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDateObj.getTime() - now;
      if (distance > 0) {
        setTimeLeft({
          days: Math.floor(distance / (1000 * 60 * 60 * 24)),
          hours: Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
          minutes: Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
          seconds: Math.floor((distance % (1000 * 60)) / 1000)
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [targetDate]);

  const timeBlocks = [
    { label: 'Days', value: timeLeft.days },
    { label: 'Hours', value: timeLeft.hours },
    { label: 'Minutes', value: timeLeft.minutes },
    { label: 'Seconds', value: timeLeft.seconds }
  ];

  // Compact variant for register page
  if (variant === 'compact') {
    return (
      <div style={{ background: '#166d13', color: 'white', padding: 24, borderRadius: 16, textAlign: 'center' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
          {showIcon && <AccessTimeIcon sx={{ mr: 1 }} />}
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            Registration Closes In:
          </Typography>
        </div>
        <Grid container spacing={1} justifyContent="center" sx={{ mb: 2 }}>
          {timeBlocks.map((block, index) => (
            <Grid item xs={3} key={index}>
              <Paper elevation={0} sx={{ 
                bgcolor: 'transparent', 
                textAlign: 'center',
                p: 1 
              }}>
                <Typography
                  variant="h4"
                  sx={{
                    fontWeight: 'bold',
                    fontSize: '1.8rem',
                    lineHeight: 1,
                    color: 'white'
                  }}
                >
                  {String(block.value).padStart(2, '0')}
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: '#fff',
                    fontWeight: 600,
                    fontSize: '0.8rem',
                    textTransform: 'uppercase',
                    letterSpacing: 1
                  }}
                >
                  {block.label}
                </Typography>
              </Paper>
            </Grid>
          ))}
        </Grid>
        <Typography
          variant="h6"
          sx={{ mt: 2, color: '#fff', fontWeight: 'bold', fontSize: '1.1rem', textShadow: '1px 1px 2px rgba(0,0,0,0.25)' }}
        >
          Event: December 11–12, 2025
        </Typography>
        <Typography
          variant="body2"
          sx={{ mt: 1, color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5, textShadow: '1px 1px 2px rgba(0,0,0,0.18)' }}
        >
          <span role="img" aria-label="location">📍</span> University of Lagos Guest Houses and Conference Centre, Akoka, Lagos
        </Typography>
      </div>
    );
  }

  // Default variant for register page
  return (
    <div style={{ textAlign: 'center', marginBottom: 32 }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16 }}>
        {showIcon && <AccessTimeIcon sx={{ mr: 1, color: '#166d13' }} />}
        <Typography
          variant="h6"
          sx={{ fontWeight: 'bold', color: '#166d13' }}
        >
          Registration Closes In:
        </Typography>
      </div>
      <Grid container spacing={2} justifyContent="center" sx={{ maxWidth: 500, mx: 'auto', mb: 2 }}>
        {timeBlocks.map((block, index) => (
          <Grid item xs={6} sm={3} key={index}>
            <Box
              sx={{
                p: 2,
                textAlign: 'center',
                bgcolor: '#166d13',
                borderRadius: 2,
                color: 'white',
                minWidth: 100,
                boxShadow: 'none',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <Typography variant="h4" sx={{ fontWeight: 'bold', fontSize: '2rem', lineHeight: 1 }}>
                {String(block.value).padStart(2, '0')}
              </Typography>
              <Typography variant="caption" sx={{ fontWeight: 'bold', fontSize: '0.85rem', textTransform: 'uppercase', letterSpacing: 1, mt: 0.5 }}>
                {block.label}
              </Typography>
            </Box>
          </Grid>
        ))}
      </Grid>
      <div style={{ marginTop: 16, color: '#166d13', textAlign: 'center', fontWeight: 'bold', fontSize: '1.05rem' }}>
        <div>Hackathon</div>
        <div style={{ fontWeight: 400 }}>
          <span role="img" aria-label="calendar">🗓</span> December 11–12, 2025
        </div>
        <div style={{ fontWeight: 400 }}>
          <span role="img" aria-label="location">📍</span> University of Lagos Guest Houses and Conference Centre, Akoka, Lagos, Nigeria
        </div>
      </div>
    </div>
  );
}

export default RegisterCountdownTimer;
